import React from 'react'
import './about.css'
import ME from '../../assets/me-about.jpeg'
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'
import {VscFolderLibrary} from 'react-icons/vsc'

const About = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
              <img src={ME} alt="About Image" />
          </div>
        </div>

        <div className="about__content">
            <div className="about__cards">

              <article className='about__card'>
                <FaAward className='about__icon'/>
                <h5>Experience</h5>
                <small>3+ Years Working</small>
              </article>
              <article className='about__card'>
                <FiUsers className='about__icon'/>
                <h5>Clients</h5>
                <small>50+ Worldwide</small>
              </article>
              <article className='about__card'>
                <VscFolderLibrary className='about__icon'/>
                <h5>Projects</h5>
                <small>100+ Completed</small>
              </article>
            </div>
            <p>From the moment I produced “Hello
                World!” in the console of my first
                application, I knew I was hooked into the
                world of Web & Software development.
                But Web development has never been “just
                a job” for me. It’s offered an engaging
                challenge to continually learn and improve
                my skills in creating high quality website
                and softwares. What started with a simple
                “Hello World!” has become a full-fledged
                passion that only gets more exciting as the
                years go by.</p>
              <a href='#contact' className='btn btn-primary'>Let's Talk</a>
        </div>
      </div>

    </section>
  )
  
}

export default About